module.exports = {
  "country": "RS",
  "artist": "Marija Serifovic",
  "song": "Molitva",
  "year": "2007",
  "place": "1",
  "spotify": "3qC3JSTCiedBhYm2oN1axx"
};